export default "__VITE_ASSET__DtNjWgUc__"